export const API_ENDPOINT =
  process.env.NODE_ENV === "production"
    ? "https://api.windenergybridge.com/api/webridge/v1"
    : "http://localhost:9200/api/webridge/v1";

export const INSIGHTS_API_ENDPOINT =
  process.env.NODE_ENV === "production"
    ? "https://api.windenergybridge.com/api/webridge/v1"
    : "http://localhost:9200/api/webridge/v1";

const ADMIN_TOKEN_KEY = "webridge_admin_token";

export function getAdminToken(): string | null {
  try {
    return localStorage.getItem(ADMIN_TOKEN_KEY);
  } catch {
    return null;
  }
}

export function setAdminToken(token: string | null): void {
  try {
    if (token) localStorage.setItem(ADMIN_TOKEN_KEY, token);
    else localStorage.removeItem(ADMIN_TOKEN_KEY);
  } catch {
    // localStorage unavailable (private browsing, etc.) — session just won't persist
  }
}

export function adminAuthHeaders(): Record<string, string> {
  const token = getAdminToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
}
